import { Analytics, SmartToy } from "@mui/icons-material";
import DetailsIcon from "@mui/icons-material/Details";
import { useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import OmniAvatar from "./omniAvatar";
import OmniListItemButton from "./omniListItemButton";

const OmniBotpressBotListItem = props => {
  const {
    botpressBotDef,
    isAnalytics = false,
    onClickHandler = null,
    onNavigateHandler = null,
  } = props;
  const theme = useTheme();

  const getSelectedIcon = theDef => {
    if (theDef.omniData.isConversationAnalytics) {
      return <Analytics />;
    } else {
      return <SmartToy />;
    }
  };

  return (
    <ListItem
      disableGutters={true}
      sx={{
        padding: theme.spacing(1),
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.spacing(1),
        borderRadius: theme.spacing(1),
        backgroundColor: !botpressBotDef.omniData.isProduction
          ? theme.palette.success.main
          : theme.palette.warning.main,
        color: theme.palette.info.contrastText,
        cursor: "pointer",
        boxShadow: theme.shadows[3],
        userSelect: "none",
        webkitUserSelect: "none",
        width: "100%",
      }}
      onClick={e => {
        e.stopPropagation();
        if (onClickHandler && !isAnalytics) {
          onClickHandler(botpressBotDef);
        }
      }}
    >
      <Tooltip title={"Click to Toggle"} placement="right">
        <>
          <OmniAvatar
            sx={{
              width: 36,
              height: 36,
              fontSize: "1.2rem",
              backgroundColor: botpressBotDef.omniData.isProduction
                ? theme.palette.success.contrastText
                : theme.palette.warning.contrastText,
              color: botpressBotDef.omniData.isProduction
                ? theme.palette.success.main
                : theme.palette.warning.main,

              border: `2px solid ${theme.palette.info.contrastText}`,
            }}
          >
            {getSelectedIcon(botpressBotDef)}
          </OmniAvatar>
        </>
      </Tooltip>
      <ListItemText
        primary={
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: theme.palette.info.contrastText,
              marginTop: 0,
            }}
          >
            {botpressBotDef.omniData.name}
          </Typography>
        }
        secondary={
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              flexDirection: "row",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: "-6px",
              color: theme.palette.info.contrastText,
              minimumHeight: 20,
            }}
          >
            {botpressBotDef.omniData.description
              ? botpressBotDef.omniData.description
              : botpressBotDef.omniData.isProduction
                ? "Production Bot"
                : "Development Bot"}
          </Typography>
        }
      />
      {onNavigateHandler && (
        <OmniListItemButton
          title={"Check Status"}
          sx={{
            marginTop: "1px",
            marginRight: "1px",
          }}
          size="large"
          onClick={e => {
            e.stopPropagation();
            //  window.location.reload();
            //todo ImplmentNavigation
          }}
          icon={<DetailsIcon />}
        />
      )}
    </ListItem>
  );
};

export default OmniBotpressBotListItem;
